import { render, staticRenderFns } from "./TableProperties.vue?vue&type=template&id=52fab890&"
import script from "./TableProperties.vue?vue&type=script&lang=js&"
export * from "./TableProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports